import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";
import projectData from "./ProjectsData";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deps: {},
      detailsModalShow: false,
      projects: projectData,
    };
  }

  render() {
    let detailsModalShow = (data) => {
      this.setState({ detailsModalShow: true, deps: data });
    };

    let detailsModalClose = () => this.setState({ detailsModalShow: false });
    return (
      <section id="portfolio">
        <div className="col-md-12">
          <h1 className="section-title" style={{ color: "black" }}>
            <span>Projects</span>
          </h1>
          <div className="col-md-12 mx-auto">
            <div className="row mx-auto">
              {this.state.projects.map((project) => (
                <div
                  className="col-sm-12 col-md-6 col-lg-4"
                  key={project.title}
                  style={{ cursor: "pointer" }}
                >
                  <span className="portfolio-item d-block">
                    <div
                      className="foto"
                      onClick={() => detailsModalShow(project)}
                    >
                      <div>
                        <img
                          src={project.images[0]}
                          alt="projectImages"
                          height="230"
                          style={{
                            marginBottom: 0,
                            paddingBottom: 0,
                            position: "relative",
                            objectFit: "cover",
                          }}
                        />
                        <span className="project-date">
                          {project.startDate}
                        </span>
                        <br />
                        <p className="project-title-settings mt-3">
                          {project.title}
                        </p>
                      </div>
                    </div>
                  </span>
                </div>
              ))}
            </div>
          </div>
          <ProjectDetailsModal
            show={this.state.detailsModalShow}
            onHide={detailsModalClose}
            data={this.state.deps}
          />
        </div>
      </section>
    );
  }
}

export default Projects;
